import { EventBus } from "OK/EventBus";
import type { IToast } from "@ok/interfaces/toast/ToastTypes";

const PREFIX = "toast";

const create = EventBus.factory(PREFIX);

export const INIT = create<void>("init");
export const SHOW = create<{ toast: IToast }>("show");
export const PUSH_TOASTS = create<{ toasts: IToast[] }>("initToasts");
